import { ADD_NOTIFICATION, RESOLVE_NOTIFICATION } from './constants';
import {
  NO_ACCESS_MESSAGE,
  NO_ACCESS_NOTIFICATION_KEY,
  NO_PRODUCTION_MONITORING_ACCESS
} from '../../../attrs/accessErrors';

const addNotification = notification => ({
  type: ADD_NOTIFICATION,
  notification:
    notification.message?.endsWith(`.${NO_PRODUCTION_MONITORING_ACCESS}`) || notification.message === NO_ACCESS_MESSAGE
      ? { ...notification, key: NO_ACCESS_NOTIFICATION_KEY, message: NO_ACCESS_MESSAGE }
      : notification
});

const resolveNotification = key => ({
  type: RESOLVE_NOTIFICATION,
  key
});

export { addNotification, resolveNotification };
